<!-- state update here {{ no$ | async }}
<button (click)="buttonState()">update state</button> -->
<router-outlet></router-outlet>